import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-schedule-exception-request-reason-dialog',
  templateUrl: './schedule-exception-request-reason-dialog.component.html',
  styleUrl: './schedule-exception-request-reason-dialog.component.css',
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    ReactiveFormsModule,
    MatLabel,
    MatFormField,
    MatInput,
    MatError,
    MatHint,
    MatDialogActions,
    MatButton,
  ],
})
export class ScheduleExceptionRequestReasonDialogComponent {
  private readonly dialog_ref = inject<MatDialogRef<ScheduleExceptionRequestReasonDialogComponent, string>>(MatDialogRef);

  protected readonly min_length = 20;

  protected readonly reason = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(this.min_length)],
  });

  protected confirm(): void {
    if (this.reason.invalid) {
      this.reason.markAsTouched();
      return;
    }

    this.dialog_ref.close(this.reason.value.trim());
  }
}
